var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiscoLogoNoTmCiscoBlueRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 774.2 534.1",
    style: {
      enableBackground: "new 0 0 774.2 534.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#02BCEA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.5,
    y: 312.2,
    className: "st0",
    width: 21.9,
    height: 86.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.2,337.1c-0.9-0.5-8-4.6-18.4-4.6c-14.2,0-24,9.9-24,23.2c0,12.9,9.4,23.2,24,23.2 c10.3,0,17.5-4.1,18.4-4.6v23.3c-2.8,0.8-10.2,3.1-20,3.1c-24.7,0-46.3-17-46.3-45c0-25.9,19.6-45,46.3-45 c10.3,0,17.9,2.5,20,3.1V337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.4,337.1c-0.9-0.5-7.9-4.6-18.4-4.6c-14.2,0-24,9.9-24,23.2c0,12.9,9.4,23.2,24,23.2 c10.3,0,17.5-4.1,18.4-4.6v23.3c-2.7,0.8-10.2,3.1-20,3.1c-24.6,0-46.3-17-46.3-45c0-25.9,19.6-45,46.3-45 c10.3,0,17.9,2.5,20,3.1V337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.1,355.6c0,24.9-19.2,45-45.9,45c-26.7,0-45.9-20.1-45.9-45c0-24.8,19.2-45,45.9-45 C572.9,310.7,592.1,330.8,592.1,355.6z M546.2,332.8c-13,0-22.7,10.2-22.7,22.8s9.7,22.9,22.7,22.9s22.7-10.2,22.7-22.9 C568.9,343,559.2,332.8,546.2,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.6,332c-0.3-0.1-9.6-2.7-17.1-2.7c-8.8,0-13.6,2.9-13.6,7.1c0,5.3,6.4,7.1,10.1,8.3l6,1.9 c14.2,4.5,20.7,14.3,20.7,24.9c0,21.8-19.2,29.2-36,29.2c-11.7,0-22.6-2.1-23.7-2.4v-20c1.9,0.5,11.1,3.2,20.7,3.2 c10.9,0,15.9-3.2,15.9-8.1c0-4.4-4.3-6.9-9.8-8.7c-1.3-0.4-3.3-1.1-4.7-1.5c-12.2-3.9-22.4-11-22.4-25.4 c0-16.2,12.2-27.2,32.4-27.2c10.7,0,20.7,2.6,21.4,2.8V332H383.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.9,218.8c0-6-4.9-10.8-10.9-10.8c-6,0-10.9,4.8-10.9,10.8v22.8c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9 V218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.7,188.9c0-6-4.9-10.9-10.9-10.9s-10.9,4.9-10.9,10.9v52.7c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9 V188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.4,147.9c0-6-4.9-10.8-10.9-10.8s-10.9,4.9-10.9,10.8v115.4c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9 V147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.2,188.9c0-6-4.9-10.9-10.9-10.9s-10.9,4.9-10.9,10.9v52.7c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9 V188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,218.8c0-6-4.9-10.8-10.8-10.8c-6,0-10.9,4.9-10.9,10.8v22.8c0,6,4.9,10.9,10.9,10.9s10.8-4.9,10.8-10.9 V218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.8,188.9c0-6-4.9-10.9-10.9-10.9s-10.9,4.9-10.9,10.9v52.7c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9 V188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517.6,147.9c0-6-4.9-10.8-10.9-10.8s-10.9,4.9-10.9,10.8v115.4c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9 V147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M577.4,188.9c0-6-4.9-10.9-11-10.9c-6,0-10.9,4.9-10.9,10.9v52.7c0,6,4.9,10.9,10.9,10.9c6.1,0,11-4.9,11-10.9 V188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.1,218.8c0-6-4.9-10.8-10.9-10.8s-10.9,4.9-10.9,10.8v22.8c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9 V218.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiscoLogoNoTmCiscoBlueRgb);
export default __webpack_public_path__ + "static/media/Cisco_Logo_no_TM_Cisco_Blue-RGB.cd26fd48d51a2e8e520c0015b1939159.svg";
export { ForwardRef as ReactComponent };